import React from 'react';
import {useSelector} from 'react-redux';
import {selectHasUsablePassword, selectReauthMethods} from '../store';
import {getEmailChangeMode} from '../utils/SocialReauth';

/**
 * Which change-email flow the signed-in user gets (backend#263): the
 * password form, "Confirm it's you" with a linked Google/Apple account, or
 * the set-password link. See `getEmailChangeMode`.
 */
const useEmailChangeMode = () => {
  const hasUsablePassword = useSelector(selectHasUsablePassword);
  const reauthMethods = useSelector(selectReauthMethods);
  return React.useMemo(
    () => getEmailChangeMode({hasUsablePassword, reauthMethods}),
    [hasUsablePassword, reauthMethods],
  );
};

export default useEmailChangeMode;
